export const labelConfig = {
    conteudos: {
        default: "Conteúdos",
        overrides: [{ canalId: 37, nivelEnsino: "EI", label: "Vivências" }]
    },
    visaoGeral: {
        default: "Componentes Curriculares",
        overrides: [
            { canalId: 37, nivelEnsino: "EI", label: "Campos de Experiências" },
            { nivelEnsino: "EI", label: "Disciplina" }
        ]
    },
    visaoGeralTabela: {
        default: "Disciplina",
        overrides: [{ canalId: 37, nivelEnsino: "EI", label: "Campo de Experiência" }]
    },
    alunos: {
        default: "Alunos",
        overrides: [{ nivelEnsino: "EI", label: "Crianças" }]
    },
    ensinoEspecialRelatorios: {
        default: "Relatórios",
        overrides: [{ canalId: 37, label: "Portfólios" }]
    },
    ensinoEspecialRelatorio: {
        default: "Relatório de Atendimento",
        overrides: [{ canalId: 37, label: "Portfólio" }]
    }
};
